import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-content-box">
        <div className="about-header-group">
          <span className="about-role-pill"><i className="fas fa-chart-line"></i> Background & Philosophy</span>
          <h2 className="about-me">About Me</h2>
        </div>
        
        <div className="professional-summary">
          <h3><i className="fas fa-user-tie"></i> Professional Summary</h3>
          <p className="data-skills">
            I am a results-oriented <strong>Data Analyst & Business Intelligence Specialist</strong> with a proven background in 
            exploratory data analysis, interactive dashboard architecture, and predictive modeling. Proficient in <strong>Power BI</strong>, 
            <strong>Tableau</strong>, <strong>SQL</strong>, <strong>Python</strong>, and <strong>Excel</strong>, I specialize in transforming raw, 
            disparate datasets into structured narratives that empower executive stakeholders to make high-confidence, data-driven decisions.
          </p>
        </div>

        {/* 3-Step Analytical Workflow */}
        <div className="workflow-section">
          <h3><i className="fas fa-project-diagram"></i> Analytical Workflow & Approach</h3>
          <div className="workflow-grid">
            <div className="workflow-step">
              <div className="step-number">01</div>
              <h4>Ingest & Cleanse</h4>
              <p>Extracting, wrangling, and validating data integrity using SQL and Python (Pandas) to build reliable single sources of truth.</p>
            </div>
            <div className="workflow-step">
              <div className="step-number">02</div>
              <h4>Model & Discover</h4>
              <p>Applying statistical testing, exploratory analysis, and predictive modeling to uncover anomalies, affinities, and trends.</p>
            </div>
            <div className="workflow-step">
              <div className="step-number">03</div>
              <h4>Visualize & Storytell</h4>
              <p>Designing executive Power BI & Tableau dashboards with clear KPI frameworks that translate numbers into actionable strategy.</p>
            </div>
          </div>
        </div>

        <div className="co-curricular-activities">
          <h3><i className="fas fa-award"></i> Core Competencies & Leadership</h3>
          <div className="competency-cards">
            <div className="tennis-section">
              <div className="comp-header">
                <i className="fas fa-users-cog"></i>
                <strong>Stakeholder Liaison & Recruiter Relations</strong>
              </div>
              <p>
                Student Coordinator, Career Development Cell (CDC). Acting as the primary operational liaison between enterprise recruiters and university talent, organizing corporate placement drives, resume workshops, and data-driven recruitment tracking.
              </p>
            </div>

            <div className="tennis-section">
              <div className="comp-header">
                <i className="fas fa-calendar-check"></i>
                <strong>Operational Planning & Coordination</strong>
              </div>
              <p>
                Core Organizing Committee, Aspire Fest. Coordinated large-scale events, overseeing logistics, cross-functional timelines, and participant data management across multi-day university celebrations.
              </p>
            </div>

            <div className="tennis-section">
              <div className="comp-header">
                <i className="fas fa-baseball-ball"></i>
                <strong>Strategic Discipline & Pattern Recognition</strong>
              </div>
              <p>
                Competitive Tennis Player (9 Years). Competing on the court has ingrained high discipline, quick pattern recognition under pressure, and a focus on continuous marginal gains — traits that directly translate to diagnostic data analytics.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
